import { useCallback, useMemo } from "react";
import { validateReturnToUrl } from "./ory";
import { useAtom } from "jotai";
import { returnToAtom } from "src/shame/shame-atoms";

// Create a custom hook
export const useReturnToStore = () => {
	const [state, setState] = useAtom(returnToAtom);

	const setReturnTo = useCallback((url: string) => {
		if (validateReturnToUrl(url)) {
			setState(url);
		}
	}, []);

	return useMemo(() => {
		return {
			returnTo: state,
			setReturnTo,
		};
	}, [state, setReturnTo]);
};
